import { defineComponent, onBeforeMount, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Breadcrumbs from '@/components/breadcrumbs'
import RightMenu from '@/components/right-menu'
import Logout from '@/components/logout'
import MobileMenu from '@/components/mobile-menu'
import OrderAddress from './components/order-address/index'
import CancelOrder from './components/cancel-order/index'
import axios from '@/axios'
import { host, hostForImage, imageOldSite } from '../const'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import './styles/order-page.sass'
import cancelOrder from './components/cancel-order/index'
import BetaVersion from "@/components/beta-version";
import ManagerLogist from "@/orders/components/manager-logist";

export default defineComponent({
  setup () {
    const route = useRoute()
    const order: any = ref([])
    const arr: any = ref([])
    const canceled = ref<boolean>(false)
    const canceledText = ref<string>('')
    const paymentText = ref<string>('')

    onBeforeMount(async () => {
      const promises = [
        axios.get(`${host}/api/v1/orders`, { params: { number: route.query.orderId } })
      ]
      const [orderItem] = await Promise.all(promises)
      order.value = orderItem.data.items[0]
      arr.value = [
        { name: 'Главная', link: '/' },
        { name: 'Заявки', link: '/' },
        { name: `Детали Заявки № ${order.value.number}`, link: '#' }
      ]
      
    })

    function getDateOrder (val: string) {
      return dayjs(val).locale('ru').format('D MMM')
    }

    function getDateFile (val: string) {
      return dayjs(val).locale('ru').format('DD.MM.YYYY')
    }

    function statusFilter(val: any) {
      if (!val?.payment) {
        paymentText.value = 'Не оплачено'
        return false;
      } else if (val?.payment < val?.totalCost) {
        paymentText.value = `Частичная оплата ${order.value.basicInvoice?.payment} ₽`
        return false;
      } else if (val?.payment > val?.totalCost) {
        paymentText.value = `Переплата ${order.value.basicInvoice?.payment - order.value.basicInvoice?.totalCost} ₽`
        return false;
      } else if (val?.payment == val?.totalCost) {
        paymentText.value = `Оплачено ${order.value.basicInvoice?.payment} ₽`
        return true;
      } else {
        paymentText.value = 'Не оплачено'
        return false;
      }
    }

    function changeDelivery () {
      console.log('changeDelivery func')
    }

    function cancelOrder() {
      canceled.value = true
    }

    function checkOrderStatus() {

      if (order.value.status == "FINISH") {
        canceledText.value = "Завершена"
        return false
      } else if (order.value.status == "CANCELLED" || order.value.status == "SPAM") {
        canceledText.value = "Отменен"
        return false
      } else {
        return true
      }
    }

    function roundSummItemOrder() {
      let sumWithoutVat = order.value.basicInvoice ? order.value.basicInvoice.totalCost - order.value.deliveryPrice : 0
      return sumWithoutVat.toFixed(2)
    }
    
    return () => {
      return (
        <div class="order-page">
          <Breadcrumbs items={arr.value}/>
          <BetaVersion />
          <h1 class="page-title">
            {`Заявка №${order.value.number} к счету ${order.value.basicInvoice ? order.value.basicInvoice.number : ''}`}
          </h1>

          <div class="main-content-two-columns">
          {canceled.value
              ? (<CancelOrder
                cancel={(value: any) => { canceled.value = value }}
                order={order.value.number}
              />
            ): null
          }
            <div>
              <div class="order-data">
                <img src={require('@/assets/calendar.svg')}  alt=""/>
                <p>от <span>{getDateOrder(order.value.basicInvoice?.createdAt)}</span></p>
              </div>

              <div class="order-content">
                  <div class="order-content-elem-left">
                    {order.value.transportCompanyTitle && order.value.deliveryAddress ? (
                      <div>
                        <div>
                          <OrderAddress
                            delivery={order.value.transportCompanyTitle}
                            address={order.value.deliveryAddress}
                          />
                        </div>
                        {order.value.basicInvoice?.logist && order.value.status !== "FINISH" && order.value.status !== "CANCELLED" && order.value.status !== "SPAM" ? (
                          <div class="orders-item-delivery">
                            Доставка
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                    {order.value.status === "FINISH"
                      ? (<div class="orders-item-delivered">Завершен</div>)
                      : null
                    }
                    {order.value.status === "CANCELLED"
                      ? (<div class="orders-item-cancelled">Отменена</div>)
                      : null
                    }
                    {order.value.status === "SPAM"
                      ? (<div class="orders-item-cancelled">Отменена / Спам </div>)
                      : null
                    }
                </div>
                {order.value.basicInvoice ? (
                  <div class="order-content-elem-right">
                    <img src={require('@/assets/wallet-icon.svg')}  alt=""/>
                    <div class="order-content-elem-pay-info">
                      <div class="order-content-elem-pay-info-title">Оплата банковской картой</div>
                      <div class="order-content-elem-pay-info-text">
                        <div class="order-content-elem-pay-info-text-item">
                          <span>Общая стоимость заявки</span>
                          <span>
                            {`${order.value.basicInvoice ? order.value.basicInvoice.totalCost : 0} ₽`}
                          </span>
                        </div>
                        <div class="order-content-elem-pay-info-text-item">
                          <span>Стоимость товаров с НДС</span>
                          <span>{`${roundSummItemOrder()} ₽`}</span>
                        </div>
                        <div class="order-content-elem-pay-info-text-item">
                          <span>Стоимость доставки</span>
                          <span>{`${order.value.deliveryPrice ? order.value.deliveryPrice : 0} ₽`}</span>
                        </div>
                        <div class="order-content-elem-pay-info-text-item-statuses">
                          {order.value.status === "IN_PROGRESS"
                            ? (<div class="order-pay-status-in-proggress">В работе</div>)
                            : null
                          }
                          {order.value.status !== "CANCELLED"
                            ? (
                              <div>
                                {statusFilter(order.value.basicInvoice) ? (
                                  <div class="order-pay-status-pay">{ paymentText.value }</div>
                                ) : <div class="order-pay-status-not-pay">{ paymentText.value }</div>}
                                {!order.value.transportCompanyTitle && !order.value.deliveryAddress
                                  ? (<div class="order-status">Ожидает отправки</div>)
                                  : null
                                }
                              </div>
                            )
                            : null
                          }
                        </div>
                      </div>
                    </div>
                  </div>) : 
                  <span>Информация о сделанных заявках может отображаться не сразу, пожалуйста подождите</span>

                }
                

                {order.value.company ? (
                  <div class="order-content-elem-left-bottom">
                    <img src={require('@/assets/buildings-icon.svg')}  alt=""/>
                    <div class="order-content-elem-left-bottom-content">
                      <div>
                        <p>{order.value.company.name}</p>
                        <p>{`ИНН - ${order.value.company.inn}`}</p>
                      </div>
                    </div>
                  </div>
                ) : null }
                {/* {statusFilter(order.value.basicInvoice?.statuses) ? ( */}
                {/*  <div class="order-pay-status-pay">Оплачено</div> */}
                {/* ) : <div class="order-pay-status-not-pay">Не оплачено</div>} */}
              </div>

              <div class="order-line"/>

                { order.value.status !== "FINISH" && order.value.status !== "SPAM" && order.value.status !== "CANCELLED" ? (
                  <div class="order-tabs">
                    {checkOrderStatus() && order.value.basicInvoice?.payment !== order.value.basicInvoice?.totalCost ? (
                        <>
                          <a href={`https://cable.ru/payment/?hash=${order.value.basicInvoice ? order.value.basicInvoice.hash : ''}`}
                             onClick={() => {
                               // @ts-ignore
                               ym(100581,'reachGoal','paymentLKSee')
                             }}
                          >Перейти к оплате</a>
                          {!order.value.basicInvoice?.payment || order.value.basicInvoice?.payment === 0
                            ? (
                            <>
                              <a target="_blank" href={`https://cable.ru/services/deliveryEdit.php?key=${order.value.linkKey}`}
                                 onClick={() => {
                                   // @ts-ignore
                                   ym(100581,'reachGoal','lkEdintDelivery')
                                 }}
                              >Изменить доставку</a>
                              <a href='#' onClick={cancelOrder}>Отменить заявку</a>
                            </>
                            )
                            : (
                            <div class="order-cancel-information">
                              <p>Для отмены заявки обратитесь к менеджеру</p>
                            </div>
                            )
                          }
                        </>
                      ) : (
                        <div class="order-cancel-information">
                          <p>Для отмены заявки обратитесь к менеджеру</p>
                        </div>
                      )
                    }
                    </div>
                  ) : null
                }
             

              <div class="order-bottom">
                {/* TODO: Пока функционала по этой штуке нету. Так что скроем временно*/}
                {/*{ !order.value.transportCompanyTitle && !order.value.deliveryAddress ? (*/}
                {/*  <div class="order-bottom-change-delivery">*/}
                {/*    <p>Для получения товара укажите способ получения </p>*/}
                {/*    <div class="orders-bottom-change-delivery-text" onClick={changeDelivery}>*/}
                {/*      <img src={require('@/assets/message-error-icon.svg')} />*/}
                {/*      <p>Указать способ получения товара</p>*/}
                {/*    </div>*/}
                {/*  </div>*/}
                {/*) : null}*/}

                {order.value.basicInvoice && order.value.basicInvoice.file ? (
                  <div class="order-bottom-head">
                    <div class="order-bottom-head-text">Документы по заявке</div>
                    {/* <div class="order-bottom-head-img">
                      <span>Загрузить документ</span>
                    </div> */}
                  </div>
                ) : null}

                <div class="order-bottom-files">
                  {order.value.basicInvoice && order.value.basicInvoice.file ? (
                    <div class="order-bottom-file">
                      <div class="order-bottom-file-name">
                        <div class="order-bottom-file-name-content">
                          <p>{order.value.basicInvoice.file.nameForSite}</p>
                          <p>{`Дата загрузки: ${getDateFile(order.value.basicInvoice?.file.dateLoad)}`}</p>
                        </div>
                      </div>
                      <a target="_blank" href={`${hostForImage}${order.value.basicInvoice.file.path}`}
                         onClick={() => {
                           // @ts-ignore
                           ym(100581,'reachGoal','lkDownloadInvoice')
                         }}
                      >
                        <img class="order-bottom-file-download" src={require('@/assets/download.svg')} alt=""/>
                      </a>
                    </div>
                  ) : null}
                </div>

                {order.value.basicInvoice && order.value.basicInvoice.items.length > 0 ? (
                  <div class="order-bottom-list">
                    <div class="order-bottom-list-title">Товары в заявке</div>
                    {order.value.basicInvoice?.items.map((item: any, id: any) => (
                      <div class="order-bottom-list-elems">
                        <div class="order-bottom-list-elem order-bottom-list-elem-image">
                          <img src={item.imageUrl ? `${imageOldSite}${item.imageUrl}` : require('@/assets/no_image.svg') }  alt=""/>
                        </div>

                        <div class="order-bottom-list-elem order-bottom-list-elem-name">
                          <p>{item.product}</p>
                          <p>{item.category}</p>
                        </div>

                        <div class="order-bottom-list-elem order-bottom-list-elem-sklad">
                          {/*<p>Склад</p>*/}
                          {/*<p>Химки</p>*/}
                        </div>

                        <div class="order-bottom-list-elem order-bottom-list-elem-quantity">
                          <p>Количество</p>
                          <p>{`${item.quantity} ${item.unit} `}</p>
                        </div>

                        <div class="order-bottom-list-elem order-bottom-list-elem-quantity">
                          <p>Стоимость с НДС</p>
                          <p>{`${item.price ? item.price : 0} ₽`}</p>
                        </div>

                        {order.value.status !== "CANCELLED" && order.value.status !== "SPAM"
                        ? (
                          <div class="order-bottom-list-elem order-bottom-list-elem-quantity">
                            {item.dateReceived && order.value.basicInvoice?.logist ? (
                              <div class="order-status-delivered">Доставлен</div>
                            ) : (order.value.basicInvoice?.logist ? (
                                <div class="order-status-delivery">Доставка</div>
                              ): null)
                            }
                          </div>
                          ) : null
                        }

                        {/* <div class="order-bottom-list-elem order-bottom-list-elem-comment" onClick={changeDelivery}>Оставить отзыв</div> */}
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>

            <div class="main-content-two-columns-right">
              <div class="main-content-two-columns-right-elem-sticky">
                <RightMenu />
                {typeof order.value.basicInvoice?.manager === "string" || typeof order.value.basicInvoice?.logist === "string"
                  ? (
                    <ManagerLogist
                      manager={order.value.basicInvoice?.manager}
                      logist={order.value.basicInvoice?.logist}
                    />
                  ) : null
                }
                <Logout />
                <MobileMenu/>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
})